import * as React from 'react';

interface IProps {
  width?: number;
}

export default (props: IProps) => {
  const {width} = props;

  return (
    <svg
      width={width}
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Icon">
        <circle id="Oval" cx="35" cy="35" r="35" fill="#0088FF" />
        <path
          id="Vector"
          d="M25 16C22.2422 16 20 18.2422 20 21V51C20 53.7578 22.2422 56 25 56H45C47.7578 56 50 53.7578 50 51V21C50 18.2422 47.7578 16 45 16H25ZM27.5 21H42.5C43.8828 21 45 22.1172 45 23.5V26C45 27.3828 43.8828 28.5 42.5 28.5H27.5C26.1172 28.5 25 27.3828 25 26V23.5C25 22.1172 26.1172 21 27.5 21ZM25 33.5C25 32.1172 26.1172 31 27.5 31C28.8828 31 30 32.1172 30 33.5C30 34.8828 28.8828 36 27.5 36C26.1172 36 25 34.8828 25 33.5ZM27.5 38.5C28.8828 38.5 30 39.6172 30 41C30 42.3828 28.8828 43.5 27.5 43.5C26.1172 43.5 25 42.3828 25 41C25 39.6172 26.1172 38.5 27.5 38.5ZM25 48.5C25 47.1172 26.1172 46 27.5 46H35C36.3828 46 37.5 47.1172 37.5 48.5C37.5 49.8828 36.3828 51 35 51H27.5C26.1172 51 25 49.8828 25 48.5ZM35 31C36.3828 31 37.5 32.1172 37.5 33.5C37.5 34.8828 36.3828 36 35 36C33.6172 36 32.5 34.8828 32.5 33.5C32.5 32.1172 33.6172 31 35 31ZM32.5 41C32.5 39.6172 33.6172 38.5 35 38.5C36.3828 38.5 37.5 39.6172 37.5 41C37.5 42.3828 36.3828 43.5 35 43.5C33.6172 43.5 32.5 42.3828 32.5 41ZM42.5 31C43.8828 31 45 32.1172 45 33.5C45 34.8828 43.8828 36 42.5 36C41.1172 36 40 34.8828 40 33.5C40 32.1172 41.1172 31 42.5 31ZM40 41C40 39.6172 41.1172 38.5 42.5 38.5C43.8828 38.5 45 39.6172 45 41C45 42.3828 43.8828 43.5 42.5 43.5C41.1172 43.5 40 42.3828 40 41ZM42.5 46C43.8828 46 45 47.1172 45 48.5C45 49.8828 43.8828 51 42.5 51C41.1172 51 40 49.8828 40 48.5C40 47.1172 41.1172 46 42.5 46Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
